export enum Languages {
  GERMAN = 'de',
  ENGLISH = 'en'
}
